import {Box, InputLabel} from '@mui/material';
import {useSetState} from 'minimal-shared/hooks';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {
  Filters,
  IndicatorTissotFilters,
  IndicatorTissotFiltersEnum,
  IndicatorTissotFiltersValues,
  IndicatorTissotParameter,
} from '../../indicator-types';
import {toIndicatorTissotFilters} from '../../utils/filter-initializer';
import {AutocompleteSelectAll} from '../_partial/autocomplete-select-all';

type Props = {
  setField: (name: keyof IndicatorTissotParameter, updateValue: string | string[] | Filters | undefined) => void;
  filters: Filters;
};

export const IndicatorFormFilter = ({setField, filters}: Props) => {
  const {state, setState} = useSetState<IndicatorTissotFilters>();
  const {t} = useTranslation();

  useEffect(() => {
    const initializedFilters = toIndicatorTissotFilters(filters);
    setState(initializedFilters);
  }, [filters, setField, setState]);

  const onChange = (name: keyof IndicatorTissotFilters, value: string[]) => {
    setField('filters', {
      ...filters,
      [name]: value,
    });
  };

  if (!state) {
    return null;
  }

  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2, mt: 2}}>
        {IndicatorTissotFiltersEnum.map((filter, index) => (
          <Box key={index} sx={{width: '45%'}}>
            <InputLabel id={`parameter-filter-${filter}`}>
              {t(`pages.pilotage-rh.indicators.fields.filters.${filter}`)}
            </InputLabel>
            <AutocompleteSelectAll
              onChange={(options) =>
                onChange(
                  filter as keyof IndicatorTissotFilters,
                  options.map((option) => (typeof option.id === 'string' ? option.id : option.id.toString())),
                )
              }
              options={(
                IndicatorTissotFiltersValues[filter as keyof typeof IndicatorTissotFiltersValues] ??
                IndicatorTissotFiltersValues.boolean
              ).map((item) => ({
                id: item.value,
                label: item.label,
              }))}
              value={(state[filter as keyof IndicatorTissotFilters] as string[]).map((value) => ({
                id: value,
                label:
                  (
                    IndicatorTissotFiltersValues[filter as keyof typeof IndicatorTissotFiltersValues] ??
                    IndicatorTissotFiltersValues.boolean
                  ).find((d) => d.value === value)?.label || '',
              }))}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};
